<template>
  <div class="animated fadeIn mt-5" v-if="dataLoaded">
    <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event, false)">
      <div class="row">
        <b-col md="6">
          <b-card>
            <div slot="header">
              <strong>Item</strong>
            </div>

            <b-form-group label="DSR">
              <b-form-input v-model="item.dsr_id" readonly />
            </b-form-group>

            <b-form-group label="Nome">
              <b-form-input v-model="item.dsr_name" readonly />
            </b-form-group>

            <b-form-group label="Username">
              <b-form-input v-model="item.dsr_username" readonly />
            </b-form-group>


            <b-form-group label="SO">
              <b-form-select v-model="item.so_code" :options="soOptions" />
            </b-form-group>


            <b-form-group label="CHA Nome">
              <b-form-input v-model="item.cha_name" readonly />
            </b-form-group>


            <b-form-group label="UFS">
              <b-form-input v-model="item.ufs_points" readonly />
            </b-form-group>

            <b-form-group label="OLA">
              <b-form-input v-model="item.ola_points" readonly />
            </b-form-group>

            <b-form-group label="Total">
              <b-form-input v-model="item.total" readonly />
            </b-form-group>


            <div slot="footer">
              <div class="row">
                <div class="col-sm-3">
                  <router-link :to="{ name: 'isolated/submitted.index' }" size="sm" variant="danger"><i
                      class="fa fa-ban"></i>
                    Cancelar</router-link>

                </div>
                <div class="col-sm-9 text-right">
                  <b-button type="submit" size="sm" variant="primary" ><i class="fa fa-save"></i>
                    Gravar</b-button>
                  <b-button type="button" v-on:click="validateBeforeSubmit($event, true)" size="sm" variant="primary"
                   ><i class="fa fa-save"></i> Gravar e fechar</b-button>
                </div>
              </div>
            </div>
          </b-card>


        </b-col>
      </div>
    </form>

  </div>
</template>

<script>

import Zones from '@/views/dealers/zones/modal.vue'
export default {
  name: 'BestofDsrObjectiveEdit',
  props: ['id'],
  components: { Zones },
  data() {
    return {
      soOptions: [],
      originalStatusId: null,
      dataLoaded: false,
      modalType: '',
      showModal: false,
      item: {
        id: null,
        dsr_id: null,
        dsr_name: '',
        dsr_username: '',
        so_code: null,
        so_name: '',
        cha_code: null,
        cha_name: '',
        ufs_points: 0,
        ola_points: 0,
        total: 0
      },
    }
  },
  watch: {
    'item.so_code'(newValue) {

      const selected = this.soOptions.find(
        x => x.value === newValue
      )

      if (selected) {
        this.item.so_name = selected.text
      }
    }
  },
  methods: {
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {

      e.preventDefault()

      this.axios.put(
        'isolated/pull_requests/' + this.item.id,
        {
          so_code: this.item.so_code
        }
      )
        .then(response => {
          this.item = response.data.data
          this.originalStatusId = this.item.status_id

          this.$bvToast.toast(
            'Item gravado com sucesso',
            {
              autoHideDelay: 5000,
              variant: 'success',
              solid: true
            }
          )

          if (close) {
            this.$router.push({
              name: 'pull_requests.index'
            })
          }
        })
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('isolated/pull_requests/' + id)
        .then(response => {
          this.item = response.data.data
          this.originalStatusId = this.item.status_id
          this.dataLoaded = true
        })
        .catch(response => {
          this.$bvToast.toast(`Este item não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'pull_requests.index'
          })
        })
    } else {
      this.dataLoaded = true
    }
    this.axios.get('isolated/pull_requests/so_list')
      .then(response => {
        this.soOptions = response.data
      })
  }
}
</script>
